var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0127 0.262451C4.1802 0.262451 0.262695 4.17998 0.262695 9.01245C0.262695 13.8449 4.1802 17.7625 9.0127 17.7625C13.8452 17.7625 17.7627 13.8449 17.7627 9.01245C17.7627 4.17995 13.8452 0.262451 9.0127 0.262451ZM13.9094 6.80275L8.39397 12.3182C8.09132 12.6209 7.60062 12.6209 7.29795 12.3182L4.11595 9.13618C3.8133 8.83353 3.8133 8.34285 4.11595 8.04018C4.4186 7.7375 4.9093 7.73753 5.21197 8.04018L7.84595 10.6742L12.8134 5.7067C13.116 5.40405 13.6067 5.40405 13.9094 5.7067C14.2121 6.00935 14.2121 6.50008 13.9094 6.80275Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSuccess);
export default __webpack_public_path__ + "static/media/message-success.65d756de16bb2a90ae36ec369206329d.svg";
export { ForwardRef as ReactComponent };